import {
    FETCH_TEAMS,
    FETCH_TEAMS_FAIL,
    FETCH_TEAMS_SUCCESS
} from './actionTypes';

export const fetchTeams = () => ({
    type: FETCH_TEAMS
});

export const fetchTeamsSuccess = teams => ({
    type: FETCH_TEAMS_SUCCESS,
    payload: teams
});

export const fetchTeamsFail = error => ({
    type: FETCH_TEAMS_FAIL,
    payload: error
});
